import { api } from '@/api';
import { PostLoginRequest, PostLoginResponse } from '@/api/type';

export const postLogin = async (data: PostLoginRequest) => {
  try {
    const res = await api.post<PostLoginResponse>(`/api/auth/login`, data, {
      headers: {
        'X-Auth-Method': 'COOKIE',
      },
      skipAuth: true,
    });
    return res.data;
  } catch (err) {
    console.error('postLogin API error:', err);
    throw err;
  }
};
